import CoreBase from '../../../../services/engines/CoreBase';
import jxWindowManager from '../../../../JxControls/JxWindowManager/JxWindowManager.jsx';

class FloatingPanelEngine_OnEntryNodesResolved extends CoreBase {
    /**
     * @param {object} cmd - OnEntryNodesResolved payload
     * @param {function} getProvider - (panelId) => SearchResultProvider|null, provided by FloatingPanelEngine
     */
    handle = (cmd, getProvider) => {
        try {
            this.logDebug(`OnEntryNodesResolved`, `rk: ${cmd.entry.rk}`);

            const windows = jxWindowManager.getAllWindows().filter((w) => w.name === 'FloatingContentPanel');
            if (windows.length === 0) return;

            windows.forEach((w) => {
                const provider = getProvider(w.id);
                if (!provider) return;

                // add to result list when provider is monitoring recent
                provider.addToResult(cmd.entry);

                // get selected entry
                const entry = provider.getSelectedEntry();

                if (!entry) return;
                if (entry.rk === cmd.entry.rk) {
                    provider.selectEntry(cmd.entry);
                }
            });
        } catch (error) {
            this.logError(`OnEntryNodesResolved`, `${error.message}`);
        }
    };
}

const floatingPanelEngine_OnEntryNodesResolved = new FloatingPanelEngine_OnEntryNodesResolved();
export default floatingPanelEngine_OnEntryNodesResolved;
